import classNames from 'classnames';

import { useBreakpoint, VSpacing, GridRow } from '@hh.ru/magritte-ui';

import CatalogLinks from 'src/components/CatalogSearch';
import ExtraFilterCatalogLinks from 'src/components/CatalogSearch/ExtraFilters';
import GridColumn from 'src/components/MagritteRedesignComponents/GridColumn';
import AbortApplyFiltersContextProvider from 'src/components/Search/Common/Filters/AbortApplyFiltersContext';
import MobileForm from 'src/components/Search/Common/Filters/MobileForm';
import Filters from 'src/components/Search/Vacancy/Filters';
import Pagination from 'src/components/SearchPagination';
import StickySidebar, { StickySidebarAndContent, SCREEN_XS_S } from 'src/components/StickySidebar';
import UnderSearchResultBanner from 'src/components/UnderSearchResultBanner';
import useSearchQualityUxFb from 'src/hooks/useSearchQualityUxFb';
import { useSelector } from 'src/hooks/useSelector';
import { SearchType } from 'src/types/search/common';

import RelatedSearches from 'src/components/VacancySearchContent/components/RelatedSearches';
import SearchResult from 'src/components/VacancySearchContent/components/SearchResult';
import Settings from 'src/components/VacancySearchContent/components/Settings';

import styles from './search-content.less';

const SearchContent = () => {
    useSearchQualityUxFb(SearchType.Vacancy);
    const paging = useSelector((state) => state.vacancySearchResult.paging);
    const isClustersEnabled = useSelector((state) => state.vacancySearchResult.isClustersEnabled);
    const totalVacancies = useSelector((state) => state.vacancySearchResult.vacancies.length);
    const showSearchPreference = useSelector(({ searchPreference }) => searchPreference.isShown);
    const catalogLinks = useSelector((state) => state.catalogLinks);
    const withSortingOrWithCounter = useSelector(({ searchPreference }) => searchPreference.isShown);

    const { isMobile } = useBreakpoint();

    const renderPagination = () => (
        <div className={styles.center}>
            <VSpacing default={40} />
            <Pagination paging={paging} />
        </div>
    );

    if (!isClustersEnabled) {
        return (
            <GridColumn xs="4" s="8" m="12">
                {!isMobile && <Settings />}
                <SearchResult />
                {paging && renderPagination()}
                {totalVacancies > 0 && <UnderSearchResultBanner />}
            </GridColumn>
        );
    }

    const filters = <Filters withCounter={withSortingOrWithCounter} withSorting={withSortingOrWithCounter} />;

    const content = (
        <main className="vacancy-serp-content">
            <SearchResult />
            {paging && renderPagination()}
            {catalogLinks?.length > 0 ? <CatalogLinks queries={catalogLinks} /> : <RelatedSearches />}
            <ExtraFilterCatalogLinks />
            {totalVacancies > 0 && <UnderSearchResultBanner />}
        </main>
    );

    return (
        <AbortApplyFiltersContextProvider>
            <div className={classNames({ 'g-hidden': showSearchPreference })}>
                <GridColumn xs="0" m="12">
                    {!isMobile && <Settings />}
                    <VSpacing default={0} gteM={16} />
                </GridColumn>
            </div>
            <StickySidebarAndContent isGridContent>
                {!isMobile && (
                    <StickySidebar>
                        <GridRow>
                            <GridColumn xs={0} m={3}>
                                <VSpacing default={24} />
                                {filters}
                            </GridColumn>
                            <GridColumn xs={0} m={1} />
                        </GridRow>
                    </StickySidebar>
                )}
                <StickySidebar disabledScreens={SCREEN_XS_S}>
                    <GridColumn xs={4} s={8}>
                        {content}
                    </GridColumn>
                </StickySidebar>
            </StickySidebarAndContent>
            {isMobile && <MobileForm>{filters}</MobileForm>}
        </AbortApplyFiltersContextProvider>
    );
};

export default SearchContent;
